module.exports = __webpack_public_path__ + "img/serbia-problem-gambling.3e49478e.png";